import { render, staticRenderFns } from "./editAvatar.vue?vue&type=template&id=5e78a8cf"
import script from "./editAvatar.vue?vue&type=script&lang=js"
export * from "./editAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports